import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AddIcon } from "../assets/images/add-document";
import ExcelIcon from "../assets/images/excel-icon";
import { RefreshIcon } from "../assets/images/refresh-icon";

interface IGridActionProps {
  onSearchClick?: (e: any) => any;
  addButtonClick?: (e: any) => any;
  excelExportClick?: (e: any) => any;
  refreshClick?: (e: any) => any;
  addButtonTooltip?: string;
  title: string;
  showAddButton?: boolean; // New prop to control visibility
}

export const GridActionComponent = ({
  onSearchClick,
  addButtonClick,
  excelExportClick,
  refreshClick,
  title,
  addButtonTooltip,
  showAddButton = true, // Default to true
}: IGridActionProps) => {
  return (
    <div className="top-sec-align row">
      <div className="d-flex">
        <h5 className="text-normal title-web mb-0">{title}</h5>

        <OverlayTrigger
          overlay={(props) => (
            <Tooltip {...props}>Type to find value from grid</Tooltip>
          )}
          placement="bottom"
        >
          <input
            type="text"
            className="form-control ms-auto search-right-align searchBg mt-1"
            placeholder="Search"
            onChange={onSearchClick}
          />
        </OverlayTrigger>

        {showAddButton && (
          <OverlayTrigger
            overlay={(props) => (
              <Tooltip {...props}>{addButtonTooltip}</Tooltip>
            )}
            placement="bottom"
          >
            <div onClick={addButtonClick} className="refresh-container">
              <AddIcon />
            </div>
          </OverlayTrigger>
        )}

        <OverlayTrigger
          overlay={(props) => <Tooltip {...props}>Reload the grid</Tooltip>}
          placement="bottom-start"
        >
          <div className="refresh-container" onClick={refreshClick}>
            <RefreshIcon />
          </div>
        </OverlayTrigger>

        <OverlayTrigger
          overlay={(props) => <Tooltip {...props}>Export Excel</Tooltip>}
          placement="bottom"
        >
          <div className="refresh-container" onClick={excelExportClick}>
            <ExcelIcon size={24} />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};
